/*
 * @Author: Merlin
 * @Date: 2023-12-01 18:13:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-15 14:15:22
 * @Description: 🥎 最近改动不小，有 console.log() 有些多
 * 暂时保留用于查验，将来删除
 */
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import { useLiveChatStore } from '@/stores/cansino/liveChat';
// --- ↑ stores --------------------------------------------------------------
import { useGameSocket } from '~/socket/game';
// --- ↑ socket --------------------------------------------------------------
import { Dialog } from 'quasar';
import { enterGame } from '@/common/js/gameJoining'; 
import {
    getGameInfo,
    getGameName,
    getGameApi,
    aGamesLosingStatus,
} from '@/common/js/gameAbout';

const showNoticeDialog = useNoticeDialog()
const isDev = import.meta.dev;
let askSum = 0 // 询问离开当前游戏计数
let sLastAccessedGame = ''; // 创建此变量为了应对页面首次加载时显示离开的游戏和进入的是同一个游戏，有此变量可有助辨别 
const {
    EMIT_UNSUBSCRIBE_ALL, // 离开游戏取消订阅
    EMIT_GAME_EXIT, // 宣告退出某个游戏
} = useGameSocket();

// ================ 👇 重要入口，监听路由变化，进入游戏时查询数据 ================

// ↓ 这里的 to 表示“将要” 跳转的目标，此时尚未到达目标页
// ↓ 因此，此刻调用 useRoute() 取的值是错的（实测得出）
export default defineNuxtRouteMiddleware(async (to, from) => {
    if (!import.meta.client) return;
    // ↓ 有参数 au 时表示登录中，将被重定向，不要向下执行 
    if (to.query.au) return;
    const t01 = Date.now();
    toRegister();
    const fromPath = from?.path || '';
    const toPath = to.path;
    const oGameLeaving = getGameInfo(fromPath);
    const oGameJoining = getGameInfo(toPath);
    const {
        gameName: sGameJoiningLax,
        isGameWithEntrance,
        indoorOrEntrance,
    } = oGameJoining; 
    if (isGameWithEntrance && !indoorOrEntrance){
        const redirectTo = getLocalPath(`/casino/${sGameJoiningLax}/entrance`);
        console.log('\n游戏页面正在重定向，中间件终止，重定向详情 ↓'); 
        console.log(toPath, '➡️', redirectTo); 
        // return + navigateTo() 需要连写，否则失效 
        return navigateTo(redirectTo, {
            replace: true,
            redirectCode: 301,
        });
    }
    const sGameLeavingStrict = oGameLeaving.gameNameStrict;
    const sGameJoiningStrict = oGameJoining.gameNameStrict;
    const hasGameChangedStrict = sGameLeavingStrict != sGameJoiningStrict;
    console.log(`\n游戏变化 (严格)：${sGameLeavingStrict || '●'} => ${sGameJoiningStrict || '●'}`);
    // ↓ 通过判断，表示当前正在“离开” 某游戏
    if (sGameLeavingStrict && hasGameChangedStrict) {
        console.log(`正在“离开”游戏：${sGameLeavingStrict}`); 
        const isGaming = useJoinStateStore().gameRunning;
        // ↓ 如果游戏正在进行中，需要询问用户是否确定要离开游戏 
        if (isGaming && 1){
            if(askSum > 0){
                return abortNavigation();
            }
            let isConfirmLeave = await askUser(sGameLeavingStrict);
            if (isConfirmLeave == false){ // 用户决定不走，要留下
                askSum = 0 //询问次数归零
                return abortNavigation(); // 终止页面跳转，留在当前游戏 
            }else{
                askSum = 0 //询问次数归零
            }
        }
        exitGame(sGameLeavingStrict);
    }
    // ↑ 以上采取 "Strict" 严格模式，即从游戏页退到游戏的入口页也视为退出游戏，以便关闭相关监听等 
    // ↑ 保持“离开游戏” 的方法在上，先取消相关订阅
    // ↓ 保持“进入游戏” 的方法在下，在退出旧游戏后再执行新的订阅（看似这个顺序更安全）
    // ================ ★★★★★ ================================================== 
    // ↓ 这里的 isChanging 致力于判断“当前游戏” 是否变化了，以期仅在变化后再执行“加入” 相关操作
    // ↓ 情景 01、在游戏页打开历史窗口，页面参数 ?id=xxx 变化将触发此处中间件，但这不属于加入游戏，不应执行加入
    // ↓ 情景 02、一些特殊游戏 xGame/indoor/2 尾部的数字（厅id）变化后也不视为加入游戏，不向下执行 
    const isChanging = (
        (hasGameChangedStrict || !oGameLeaving.gameName)
        || (sGameJoiningLax != sLastAccessedGame)
    );
    const doEnter = sGameJoiningLax && isChanging;
    console.log(`进入游戏判定 (宽松)：`, doEnter); 
    console.log("进入游戏详情 (宽松)：", (sLastAccessedGame || '■'), '=>', (sGameJoiningLax || '■')); 
    if (doEnter) {
        // 当前，特殊游戏 (isGameWithEntrance) 在访问入口页/游戏页时 “都” 会向下执行，并进行相关查询 
        // 此亦无妨，因为区别于传统游戏，特殊游戏“不会” 在这里的 enterGame() 方法内调用 EMIT_GAME_JOIN() 
        // 即不在中间件这里向后台报告某用户 “加入了” 游戏，而是仅查询游戏配置（查厅列表等）
        // 反之，如果特殊游戏在此调用 EMIT_GAME_JOIN() 将为切换厅操作添加麻烦，需要警惕。而是要在游戏内部调用 _join()
        // 综上，所以这种“都” 向下执行的现状无害（一定程度上是健壮的容错的）可以保留 
        // 这里的二次查询影响小，保留无妨。将来是否需要优化，观察中  
        sLastAccessedGame = sGameJoiningLax; // 记录上次访问的游戏 
        enterGame(sGameJoiningLax, {to});
    }
    isDev && console.log(`中间件执行完毕 🎉 耗时：${Date.now() - t01}ms`);
});


let hasRegistered = false;
/**
 * @description: 注册一个方法，用于页面跳转后记录 “已经” 到达了游戏页面
 * @return {void}
 */
function toRegister() {
    if (hasRegistered) return;
    hasRegistered = true;
    useRouter().afterEach((to, from, failure) => {
        if (failure){
            return; // 如果跳转被拦截了，不要向下执行 
        }
        const gameOfRoute = getGameName(to.path);
        // console.log(`已经到达游戏页：${gameOfRoute} `);
        const oData = {
            gameOfRoute: gameOfRoute || '', // 记录新游戏，或清除旧游戏 
        };
        useGameHistoryStore().setState(oData);
        useJoinStateStore().setState(oData);
    });
}

// ↓ 询问用户是否确认要离开当前游戏
async function askUser(
    sGameLeavingStrict, // 正在试图退出的游戏名 
){
    askSum = askSum + 1
    let fnResolve = (isConfirm) => {};
    const oPromise = new Promise((f1, f2) => fnResolve = f1);
    const { $i18n } = useNuxtApp();
    const {t: $t} = $i18n;
    const message = (()=>{
        let sResult = $t('exitGame.gameRunning');
        const isGameLosingStatus = aGamesLosingStatus.includes(
            sGameLeavingStrict,
        );
        if (!isGameLosingStatus) {
            // ↓ 提示用户下次回到游戏时将重载残局
            sResult += ` (${$t('exitGame.willSave')})`;
        }
        return sResult;
    })();
    const result = await showNoticeDialog({
        title: $t('Note'),
        mainText: message,
        mainTextStyle:'font-size: 12px;font-weight: 600;line-height: 18px;',
        giftIcon:false,
        cancelButtonText: $t('exitGame.confirm'),
        buttonText: $t('exitGame.cancel'),
        themeStyle:'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
        dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,           // 狗狗图片（可选）
        bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,          // 背景图片（可选）
        oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,          // 浮动图片（可选）
    });
    if (result) {
        fnResolve(false);
    } else {
        fnResolve(true);
    }
    // Dialog.create({
    //     persistent: true, // 强制用户一定要做选择 
    //     title: $t('exitGame.title'),
    //     message,
    //     style: { 'maxWidth': '430px' }, 
    //     ok: {
    //         label: $t('exitGame.confirm'),
    //     },
    //     cancel: {
    //         label: $t('exitGame.cancel'),
    //     },
    // }).onOk(() => {
    //     fnResolve(true);
    // }).onCancel(() => {
    //     fnResolve(false);
    // });
    return oPromise;
}


// ------ 👇 以下是离开游戏调用的方法 -------------------------------

/**
 * @description: 报告后台：用户已经离开某游戏
 * @param {string} sGameLeavingStrict 游戏名称
 * @return {void}
 */
function exitGame(
    sGameLeavingStrict, // 正在退出的游戏名 
) {
    const sApi = getGameApi(sGameLeavingStrict);
    console.log('正在离开游戏 =>', sApi);
    // ↓ 此方法对 crash, circle 意义重大，需要保留
    sApi && !['zhajinhua', 'jisuzhajinhua','niuniu','redpacket'].includes(sApi) && EMIT_GAME_EXIT(sApi);
    sApi && EMIT_UNSUBSCRIBE_ALL(sApi);
    // circle游戏退出时调用exit接口
    if (sApi === 'circle'){
        // 离开游戏时，清空暂存的下注状态，下次进入时重新获取，以防出现状态没有实时更新的情况
        useJoinStateStore().setState({
            state: {}
        });
    }
    
    // 离开游戏时，清空下注记录(实时图表)
    useLiveChatStore().bets = [0];
}

